import Vue from "vue";
import Vuex from "vuex";
import { getUrlParams } from "@/utils";

Vue.use(Vuex);

const themeType = getUrlParams("themeType");

export default new Vuex.Store({
  state: {
    domain: "",
    token: "",
    username: "",
    nickname: "",
    isAuth: false,
    theme: themeType ? themeType : "light",
    navData: [
      {
        label: "金榜首页",
        value: "home",
        icon: "icon_xh iconicon_home"
      },
      {
        label: "机构预测排行",
        value: "organization",
        icon: "icon_xh iconicon_org"
      },
      {
        label: "分析师预测排行",
        value: "analyst",
        icon: "icon_xh iconicon_analyst"
      },
      {
        label: "机构关注行业",
        value: "industry",
        icon: "icon_xh iconicon_industry"
      },
      {
        label: "个股盈利预测",
        value: "stock",
        icon: "icon_xh iconicon_stock"
      }
    ]
  },
  mutations: {
    changeThemeType(state, data){
      state.theme = data;
    }
  },
  actions: {},
  modules: {},
  getters: {
    themeType(state) {
      return state.theme;
    }
  }
});
